import { render, staticRenderFns } from "./CambiarDatosPasoTres.vue?vue&type=template&id=3b97e6a6"
import script from "./CambiarDatosPasoTres.vue?vue&type=script&lang=js"
export * from "./CambiarDatosPasoTres.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports